module.exports = __webpack_public_path__ + "images/maskable_icon-48.f8bc1e9232177af008b57defe89e70c9.png";